import React from 'react';
import { Quote } from 'lucide-react';
import { moreTestimonials } from '../data/constants';
export function MoreTestimonials() {
  return <section className="py-20 px-4 max-w-5xl mx-auto" data-id="element-160">
      <div className="text-center mb-12" data-id="element-161">
        <p className="text-primary font-bold text-sm uppercase tracking-wider mb-3" data-id="element-162">
          Historias reales
        </p>
        <h2 className="text-3xl md:text-5xl font-extrabold flex items-center justify-center gap-3 flex-wrap" data-id="element-163">
          <span data-id="element-164">❤️</span> MÁS PROFES QUE YA LO TIENEN
        </h2>
        <p className="text-zinc-400 mt-4 max-w-2xl mx-auto" data-id="element-165">
          Profes reales de toda Argentina contando lo que cambió en sus clases y
          en sus domingos.
        </p>
      </div>

      <div className="grid md:grid-cols-2 gap-6" data-id="element-166">
        {moreTestimonials.map((t, i) => <div key={i} className="relative bg-surface border border-zinc-800 hover:border-primary/40 transition-colors p-6 md:p-7 rounded-2xl flex flex-col" data-id="element-167">
            <Quote className="absolute top-5 right-5 w-8 h-8 text-primary/15" data-id="element-168" />

            <div className="flex items-center gap-3 mb-4" data-id="element-169">
              <div className="w-14 h-14 rounded-full bg-primary/10 border-2 border-primary/40 flex items-center justify-center font-space-grotesk font-bold text-lg text-primary shrink-0" data-id="element-170">
                {t.initials}
              </div>
              <div className="min-w-0" data-id="element-171">
                <div className="font-bold text-white text-base" data-id="element-172">
                  {t.name}{' '}
                  <span className="text-xs font-normal text-zinc-500" data-id="element-173">
                    · {t.age} años · {t.location}
                  </span>
                </div>
                <div className="text-xs text-primary font-medium mt-0.5" data-id="element-174">
                  {t.role}
                </div>
              </div>
            </div>

            <div className="text-yellow-400 text-sm mb-3" data-id="element-175">
              ⭐⭐⭐⭐⭐ <span className="text-zinc-500 ml-1" data-id="element-176">5.0</span>
            </div>

            <p className="text-zinc-300 italic text-sm leading-relaxed" data-id="element-177">
              "{t.text}"
            </p>

            <div className="mt-4 pt-4 border-t border-zinc-800/70 flex items-center gap-2 text-xs text-zinc-500" data-id="element-178">
              <span className="w-2 h-2 rounded-full bg-primary" data-id="element-179"></span>
              Compra verificada · Comentario público
            </div>
          </div>)}
      </div>
    </section>;
}